module.exports = __webpack_public_path__ + "img/工程.e13a24d1.png";